import React from 'react';
import { InfoImage } from 'src/assets/images';
import './special-rates.scss';

const SpecialRates = () => {
  return (
    <section className="special-rates-container">
      <img src={InfoImage} alt="info" />
      <div>
        <h2>Special rates if you earn &gt;R250 000</h2>
        <p>If monthly turnover exceeds R250 000, contact us on 011 066 0849 for custom rates.</p>
      </div>
    </section>
  );
};

export default SpecialRates;
